<template>
  <section>
    <div :class="{ loading: !isLoaded }" class="container">
      <h1>
        ON A MISSION<br />
        TO HELP INNOVATORS & STARTUPS
      </h1>
      <h2>
        to change the world with top-tier web apps
      </h2>
      <div class="cta">
        <button @click="$router.push({ name: 'About' })">
          Learn more
        </button>
        <button @click="$router.push({ name: 'GetInTouch' })">
          Get in touch
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import isLoaded from "@/mixins/isLoaded";

export default {
  name: "Home",
  mixins: [isLoaded],
  data() {
    return {
      delay: 600
    };
  }
};
</script>

<style lang="scss" scoped>
section {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.3)),
    url("~@/assets/img/home.jpg");

  > div {
    opacity: 1;
    transition: opacity 1s ease;

    &.loading {
      opacity: 0;
    }
    h1 {
      text-shadow: 0 0 6px #000000;
      @media (min-width: 992px) {
        font-size: 3em;
      }
    }
    h2 {
      text-shadow: 0 0 4px #000000;
      @media (min-width: 992px) {
        font-size: 1.5em;
      }
    }

    div.cta {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      margin-top: 10vh;
      @media (min-width: 560px) {
        flex-direction: row;
      }

      button {
        padding: 0.6rem 1.5rem;
        border-radius: 20px;
        box-shadow: 0 0 4px -2px #000000;
        margin: 0.5rem 0;
        font-size: 1.2em;
        text-transform: uppercase;
        letter-spacing: 1px;
        @media (min-width: 560px) {
          margin: 0 1rem 0 0;
          font-size: 1.3em;
        }
        @media (min-width: 812px) {
          padding: 0.6rem 1.7rem;
        }
        font-weight: 600;
        color: #ffffff;
        background-color: #4b95d7;
        border: none;
        outline: none;

        --color: #4b95d7;
        --hover: #4b95d7;

        &:hover,
        :focus {
          animation: pulse 0.8s infinite;
          box-shadow: 0 0 0 0.5em rgba(#fff, 0);
        }

        &:first-child {
          text-shadow: 0 0 7px #000000;
          background: none;
          color: #f0eff4;
          border: 1.6px solid #f0eff4;

          --color: #f0eff4;
          --hover: #f0eff4;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
